import { cn } from '~/shared/lib/cn'
import { LocalIcon, Text } from '~/shared/ui'
import type { ClaimPrefix, ClaimPrefixOption } from '../lib/types'

const CLAIM_PREFIX_OPTIONS: ClaimPrefixOption[] = [
  { code: 'DN', label: 'DN - Correspondence' },
  { code: 'RR', label: 'RR - Refund Request' },
]

interface ClaimPrefixSelectorProps {
  value: ClaimPrefix | ''
  optiSuggestedPrefix?: ClaimPrefix | ''
  onChange: (prefix: ClaimPrefix) => void
}

export function ClaimPrefixSelector({
  value,
  optiSuggestedPrefix,
  onChange,
}: ClaimPrefixSelectorProps) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <LocalIcon
          name="checkDoc"
          size="18"
          className="text-content-medium-emphasis"
        />
        <Text appearance="BODY2">Validate Claim Prefix</Text>
      </div>
      <div className="flex gap-2">
        {CLAIM_PREFIX_OPTIONS.map((option) => {
          const isOptiSuggested = optiSuggestedPrefix === option.code
          const isSelected = value === option.code
          return (
            <button
              key={option.code}
              type="button"
              className={cn(
                'inline-flex w-fit cursor-pointer items-center gap-1.5 rounded border px-2.5 py-1 text-sm whitespace-nowrap transition-colors',
                isSelected
                  ? 'border-[rgba(0,100,149,0.50)] bg-[rgba(0,100,149,0.12)] font-normal text-[#004261]'
                  : 'border-[rgba(25,28,29,0.30)] bg-transparent text-[rgba(25,28,29,0.87)]',
              )}
              onClick={() => onChange(option.code)}
            >
              {isOptiSuggested && (
                <LocalIcon
                  name={isSelected ? 'opti' : 'optiSad'}
                  size="16"
                />
              )}
              {option.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
